export const STATEMENTS = {
  healthy_living: {
    available: true,
    order: 12,
    bpart_path: "s-leefomgeving",
    tellit: {
      nl: "cd3a1f82cd913db9b0997b3a",
      fr: "b0ced5f7985b3c6e86f4322f",
    },
  },
  profit: {
    available: true,
    order: 11,
    bpart_path: "s-winst",
    tellit: {
      nl: "acd23b18c731a76a2cfc5aeb",
      fr: "073fc48d9f41a6ec280736c2",
    },
  },
  daily_care_tasks: {
    available: true,
    order: 10,
    bpart_path: "s-uitbesteden",
    tellit: {
      nl: "0684a26a3348f94c3b3a9d70",
      fr: "3c44055e31a446867fb36697",
    },
  },
  pensioen: {
    available: true,
    order: 9,
    bpart_path: "s-pensioen",
    tellit: {
      nl: "7087c65b81cf7c722c729ea3",
      fr: "664dadc303c40cc7d36df0bd",
    },
  },
  levensjaren: {
    available: true,
    order: 8,
    bpart_path: "s-levensjaren",
    tellit: {
      nl: "3563d4927b1f785e514899c3",
      fr: "32b483b1a9b638f558665f3a",
    },
  },
  zorgopleidingen: {
    available: true,
    order: 7,
    bpart_path: "s-zorgopleidingen",
    tellit: {
      nl: "4cf4d2a2ceb4387152226720",
      fr: "bd1bd2e222d5fbdd2ebaaebe",
    },
  },
  zelfzorg: {
    available: true,
    bpart_path: "s-zelfzorg",
    order: 4,
    tellit: {
      nl: "83fcea6d440e3e07ebb43e65",
      fr: "b79173a0272bcf1fc439c127",
    },
  },
  armoede: {
    available: true,
    bpart_path: "s-armoede",
    order: 5,
    tellit: {
      nl: "9ab15af7d928e0c0b1f0381f",
      fr: "63245a8674d744b6e1821b03",
    },
  },
  technologie: {
    available: true,
    order: 6,
    bpart_path: "s-technologie",
    tellit: {
      nl: "e0cb17e4c6ac0d58570f7152",
      fr: "8a622f788618015c01724841",
    },
  },
  zinloos: {
    available: true,
    order: 1,
    bpart_path: "s-zinloos",
    tellit: {
      nl: "6c11c4b1cb6cf909677231ea",
      fr: "785631a793c0f0eac7ea7cd5",
    },
  },
  toegang: {
    available: true,
    order: 2,
    bpart_path: "s-toegang",
    tellit: {
      nl: "5fcebf06712b574ff00a9b21",
      fr: "628825934ebfcaff379986c4",
    },
  },
  ontwikkeling: {
    available: true,
    order: 3,
    bpart_path: "s-ontwikkeling",
    tellit: {
      nl: "dbcaec1f711fbdc54635eab8",
      fr: "2e1776f1beb78ff7b568ede4",
    },
  },
};

export const STATEMENT_KEYS = Object.keys(STATEMENTS);
